import { B, Text } from '@ohgoodlord/design-system'

type JourneyAction =
  | 'addressDetails'
  | 'incomeDetails'
  | 'collectRefereeDetails'
  | 'collectDocumentEvidence'
  | string // covers other action not named

export const getConfirmationTitle = (action: JourneyAction): string => {
  switch (action) {
    case 'incomeDetails':
      return 'Restart income'
    case 'collectRefereeDetails':
      return 'Restart referee collection'
    case 'collectDocumentEvidence':
      return 'Restart document collection'
    case 'addressDetails':
      return 'Restart address details'
    case 'forwardingAddress':
      return 'Restart forwarding address'
    default:
      return 'Restart section'
  }
}

export const getConfirmationDescription = (action: JourneyAction): React.ReactNode => {
  switch (action) {
    case 'incomeDetails':
      return (
        <>
          <Text>
            <B>This will delete all your answers for this income.</B>
          </Text>
          <Text>Any previously provided incomes will not be deleted.</Text>
        </>
      )
    case 'collectRefereeDetails':
      return (
        <>
          <Text>
            <B>All referee details entered so far will be lost.</B>
          </Text>
        </>
      )
    case 'collectDocumentEvidence':
      return (
        <>
          <Text>
            <B>Any documents uploaded so far will be lost.</B>
          </Text>
        </>
      )
    case 'forwardingAddress':
      return (
        <>
          <Text>
            <B>
              This will delete any forwarding address details you have entered so far.
            </B>
          </Text>
        </>
      )
    case 'addressDetails':
      return (
        <>
          <Text>
            <B>This will delete all addresses entered in this section so far.</B>
          </Text>
          <Text>
            We will start the section from the beginning and ask all the questions again
            for you.
          </Text>
        </>
      )
    default:
      return (
        <>
          <Text>
            <B>This will delete all your answers in this section so far.</B>
          </Text>
          <Text>
            We will start the section from the beginning and ask all the questions again
            for you.
          </Text>
        </>
      )
  }
}
